import { render } from "./VenueSelectRON.vue?vue&type=template&id=20a37fa2"
import script from "./VenueSelectRON.vue?vue&type=script&lang=js"
export * from "./VenueSelectRON.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/VenueSelectRON.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20a37fa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20a37fa2', __exports__)) {
    api.reload('20a37fa2', __exports__)
  }
  
  module.hot.accept("./VenueSelectRON.vue?vue&type=template&id=20a37fa2", () => {
    api.rerender('20a37fa2', render)
  })

}


export default __exports__